import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { checkAuthorities, checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";

export interface FilterOptions {
  requiredRole?: string[];
  forbiddenRole?: string[];
  requiredAuthorities?: string[];
}

interface FilteredItem {
  filter?: FilterOptions;
}

export default function useFilter() {
  const checkItem = (item: FilteredItem, authUser: User | null, authorities: string[]): boolean => {
    if (!item.filter) {
      return true;
    }
    if (item.filter.requiredRole && item.filter.requiredRole.every(i => i !== authUser?.role)) {
      return false;
    }
    if (item.filter.forbiddenRole && checkRole(authUser?.role || "", item.filter.forbiddenRole)) {
      return false;
    }
    if (item.filter.requiredAuthorities && !checkAuthorities(authorities, item.filter.requiredAuthorities)) {
      return false;
    }
    return true;
  };
  const filterArray = <T extends FilteredItem>(
    items: Array<T>,
    authUser: User | null,
    authorities: string[]
  ): Array<T> => {
    return items.filter(item => checkItem(item, authUser, authorities));
  };

  const filterMap = <T extends FilteredItem>(
    items: Record<string, T>,
    authUser: User | null,
    authorities: string[]
  ): { [p: string]: T } => {
    const asArray = Object.entries(items);
    const filtered = asArray.filter(([, value]) => checkItem(value, authUser, authorities));
    return Object.fromEntries(filtered);
  };

  return {
    filterArray,
    filterMap,
  };
}
